export default {
    'Email': 'Email',
    'Email Placeholder': 'Enter your email',
    'Back to login': 'Back to login',
    'Restore Password Button': 'Restore your password',
    'Restore Password Text': 'To restore your password, enter your email address',
    'Timezone': 'Timezone',
    'Language': 'Language',
    'Avatar': 'Avatar',
    'SystemDefaultLanguage': 'Language',
    'Name': 'Name',
    'Surname': 'Surname',
    'Save Changes': 'Save Changes',
    'restoreStatusTextFirst': 'A password reset request has been sent.',
    'restoreStatusTextSecond': 'You will receive an email shortly.',
    'restoreStatusTextErrorFirst': 'We could not find this email address.',
    'restoreStatusTextErrorSecond': 'Check the entered data and try again.',
    'New Password Title': 'Password recovery',
    'New Password': 'new password',
    'New Password Placeholder': 'Enter your password',
    'Confirm new password': 'Confirm new password',
    'Confirm Password Placeholder': 'Enter your password ',
    'Notifications': 'Notifications',
    'Mark as read': 'Mark as read',
    'Unread': 'Unread',
    'It has not been implemented yet': 'It has not been implemented yet',
    'Left a comment to': 'Left a comment to',
    'Checked': 'Checked',
    'online lesson': 'online lesson',
    'Connect here': 'Connect here',
    'rated the': 'rated the',
    'opened access to the': 'You have access to',
    'new module': 'new module',
    'returned the test': 'returned the test',
    'back to work': 'back to work',
    'There are no classes this week': 'There are no classes this week',
}
